module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAAAAXNSR0IArs4c6QAAAQpJREFUOBHtk70OAUEQx60jQUOE11HiLbRqtVqt1iq1EhFqjUehQKIg4fw23GVv3N5aUZpkcjPz/7jN3azKZUQYhm3gQFCOSqmNmLlbzM6kjK1NmbcB38xdZqGP6d/M52s9uT/9ZoXo/SxThboV9a9njBvzKtyu0d+o1yxy8s9DGskNdfR38J5hnCwBxw4DE+4n1Skd7ImpsNSDFOn7CHGenFpM9Hj4rsqYIAjImVaKGGXI7BAmRXJumI3t7A8QjErkipy46ApSDdLyRTywLx0pglNmdgG7m5jU5hg0yCj2JtlVI2pGQp47ueH6pPomfBr6xHFIszrIOUY9C9dF97LTJ7uSCy9VOvn0ACe9Q4kJW0yiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/install-icon.png
// module id = 256
// module chunks = 0